import React, { MouseEventHandler } from 'react';
import { ReactComponent as IconRestart } from '../../assets/icon-restart.svg';
import { Color } from '../../utils';

import styles from './styles.module.css';

interface ButtonProps {
  color: Color;
  secondary?: boolean;
  children?: React.ReactNode;
  icon?: boolean;
  onClick?: MouseEventHandler;
}

const Button = (props: ButtonProps) => {
  return (
    <div onClick={props.onClick} className={`${styles['button']} ${styles[props.color]} ${props.secondary && styles['secondary']} ${props.icon && styles['icon']}`}>
      { props.icon && <IconRestart/>}
      { !props.icon && props.children}
    </div>
  );
}

export default Button;
